import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { ServicejobSearchResultDetailBranchComponent } from './servicejob-search-result-detail-branch.component';
import { ObjectDetailComponentModule } from '../object-detail/object-detail.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    ObjectDetailComponentModule,
  ],
  declarations: [ServicejobSearchResultDetailBranchComponent],
  exports: [ServicejobSearchResultDetailBranchComponent],
})
export class ServicejobSearchResultDetailBranchModule {}
